export class InvalidIsoCountryError extends Error {
  constructor(value: string) {
    super(`Not an ISO 3166-1 alpha-2 country code: ${value}`)
  }
}

export class ISOCountry {
  private readonly value: string

  constructor(value: string) {
    this.value = value
  }

  equals = (other: ISOCountry): boolean => other.isOneOf([this.value])

  isOneOf = (codes: ReadonlyArray<string>): boolean =>
    codes.includes(this.value)
}

export class ISOCountryFactory {
  fromString = (value: string): ISOCountry => {
    if (/^[A-Z]{2}$/.test(value)) {
      return new ISOCountry(value)
    } else {
      throw new InvalidIsoCountryError(value)
    }
  }
}
